import { useQuery } from '@tanstack/react-query';
import { getCalibrationRun, resolveUsers } from '../api/api';
import type { RunDetail } from '../components/detail/types';
import { QK } from '../lib/query-keys';

// Detail payload as it comes off the wire: `createdBy` is a bare user UUID,
// resolved into an `AISUser` (same as the list) before the page consumes it.
type RawRunDetail = Omit<RunDetail, 'createdBy'> & { createdBy?: string };

// Keyed under the runs namespace + id so it shares invalidation with the list.
export const runDetailQueryKey = (runId: string) => QK.calibration.runs.detail(runId);

export function useRunDetail(runId: string) {
  return useQuery({
    queryKey: runDetailQueryKey(runId),
    queryFn: async ({ signal }): Promise<RunDetail> => {
      const detail = await getCalibrationRun<RawRunDetail>(runId, signal);
      const id = detail.createdBy?.trim();
      if (!id) return { ...detail, createdBy: undefined };
      const users = await resolveUsers([id]);
      return { ...detail, createdBy: users.get(id) ?? { id, name: id } };
    },
    enabled: !!runId,
  });
}
